import { meshBounds, useGLTF } from '@react-three/drei'
import { useLoader, useThree } from '@react-three/fiber'
import { useEffect, useRef, useState } from 'react'
import { Audio, AudioListener, AudioLoader } from 'three'

export default function CassettePlayer()
{
    const model = useGLTF('./models/electro/cassette_player/cassette_player_1k.gltf')
    useEffect( () => 
    {
        model.scene.traverse( (child) => {
            if (child.isMesh) {
                child.castShadow = true
                child.raycast = meshBounds
            }
        })
    },[model])

    /**
     * Sounds
     */
    const { camera } = useThree()

    // Click Sound
    const clickSound = useLoader(AudioLoader, './sounds/analog-appliance-button-6-185281.mp3')
    const playClickSound = (event) => {
        const listener = new AudioListener() // connect to camera
        camera.add(listener)
        const sound = new Audio(listener) // player
        sound.setBuffer(clickSound)
        sound.setVolume(0.5)
        sound.play()
        sound.onEnded(()=>{camera.remove(listener)})
    }

    // Cassette Sound
    const cassetteSound = useLoader(AudioLoader, './sounds/industrial-carpenter-using-electric-table-saw-to-cut-timber-9942.mp3')
    const [ playerOn, setPlayerOn ] = useState(false)
    const cassetteSoundRef = useRef()
    useEffect(()=>{
        const listener = new AudioListener()
        camera.add(listener)
        const sound = new Audio(listener)
        sound.setBuffer(cassetteSound)
        sound.setVolume(0.5)
        // sound.play()
        sound.setLoop(true)
        cassetteSoundRef.current = sound
        return () => {camera.remove(listener)}
    },[camera,cassetteSound])

    // onClick
    const eventHandler = (event) => {
        event.stopPropagation()
        playClickSound()
        setPlayerOn(!playerOn)
        if (!playerOn) {
            cassetteSoundRef.current?.play()
        } else {
            cassetteSoundRef.current?.pause()
        }
    }

    return <primitive 
        object={model.scene}
        position={[1, -2, -1.2]}
        rotation={[-Math.PI/2, 0, 1]}
        scale={2}

        raycast={meshBounds}
        onClick={eventHandler}
        onPointerEnter={()=>{document.body.style.cursor = 'pointer'}}
        onPointerLeave={()=>{document.body.style.cursor = 'default'}}
    />
}